module.exports = __webpack_public_path__ + "documents/kyle+resume_12-11-18-660be9cdd146d3be8a286127c839ff85.pdf";